module.exports = __webpack_public_path__ + "media/images/common/logo_bg-9c82f4c4680412547f4c70494846c05f.png";